import React, { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import { getSubAssetDetail } from "./SubAssetHelper";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import HtmlContent from "../../components/HTMLContent";
import { taxOptions } from "../../config";
// import { Button } from "../../components/ui/button";
import SubAssetSummary from "../Reports/Statements/SubAssetSummary";

import { useOrganization } from "../../lib/context/OrganisationContext";

const SubAssetDetailsPopup = ({
  subAssetId,
  showView,
  setShowView,
  trustId,
  subAsset,
  assetId,
}) => {
  const { organizationData } = useOrganization();

  const [subAssetDetail, setSubAssetDetail] = useState(null);
  const [subAssetLoading, setSubAssetLoading] = useState(true);
  const [showStatement, setShowStatement] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };

  useEffect(() => {
    async function fetchData() {
      const subAssetDetailData = await getSubAssetDetail(subAssetId, true);
      setSubAssetDetail(subAssetDetailData);
      setSubAssetLoading(false);
    }
    fetchData();
  }, [subAssetId, setSubAssetDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`${getModuleNamingBySlug(
        organizationData?.organizationData,
        "sub-assets",
        "Sub Asset"
      )} Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {subAssetLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <div className="modal-content">
              <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                {getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "sub-assets",
                  "Sub Asset"
                )}{" "}
                Details
                {/* <div>
                  <Button
                    className="p-2 h-6 mb-1.5"
                    onClick={() => {
                      toggleStatement();
                    }}
                  >
                    View Statement
                  </Button>
                </div> */}
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "sub-assets",
                      "Sub Asset"
                    )}{" "}
                    Name:
                  </strong>{" "}
                  {subAssetDetail?.name ? subAssetDetail?.name : "-"}
                </p>
                <p>
                  <strong>
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "sub-assets",
                      "Sub Asset"
                    )}{" "}
                    Identifier:
                  </strong>{" "}
                  {subAssetDetail?.identifier
                    ? subAssetDetail?.identifier
                    : "-"}
                </p>
                <p>
                  <strong>Estimated/Reserved Value ($):</strong>{" "}
                  {subAssetDetail?.estimated_value
                    ? formatNumber(Number(subAssetDetail?.estimated_value))
                    : "-"}
                </p>
                <p>
                  <strong>
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "vendors",
                      "Vendor"
                    )}
                    :
                  </strong>{" "}
                  {subAssetDetail?.vendor
                    ? formatSubcontractorName(subAssetDetail?.vendor)
                    : "-"}
                </p>
                <p>
                  <strong>
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "assets",
                      "Asset"
                    )}
                    :
                  </strong>{" "}
                  {subAssetDetail?.asset?.name
                    ? subAssetDetail?.asset?.name
                    : "-"}
                </p>

                <p>
                  <strong>GST/VAT Applicable:</strong>{" "}
                  {subAssetDetail?.tax_type
                    ? taxOptions?.find(
                        (item) => item.value === subAssetDetail?.tax_type
                      )?.label
                    : "-"}
                </p>
                {subAssetDetail?.tax_type === "1" && (
                  <p>
                    <strong>Tax Percentage (%):</strong>{" "}
                    {subAssetDetail?.tax_percentage
                      ? `${subAssetDetail?.tax_percentage}%`
                      : "0%"}
                  </p>
                )}
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Description:</strong>{" "}
                  <HtmlContent
                    html={
                      subAssetDetail?.description
                        ? subAssetDetail?.description
                        : ""
                    }
                  />
                </p>
              </div>
            </div>
          </div>
        )}
        <ResponsiveDrawerForm
          description={""}
          title={"Sub Asset Statment"}
          handleOpen={() => {}}
          handleClose={() => {}}
          className="xl:max-w-[50vw]"
          open={showStatement}
          buttonClassName={""}
          setOpen={setShowStatement}
          read={true}
        >
          <SubAssetSummary
            id={subAssetId}
            trustId={trustId}
            subAsset={subAsset}
            assetId={assetId}
          />
        </ResponsiveDrawerForm>
      </>
    </ResponsiveDrawerForm>
  );
};

export default SubAssetDetailsPopup;
